import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/search.svg'
import _imports_1 from '@/assets/icons/pagefirstenabled.svg'
import _imports_2 from '@/assets/icons/pagefirstdisabled.svg'
import _imports_3 from '@/assets/icons/pagelastenabled.svg'
import _imports_4 from '@/assets/icons/pagelastdisabled.svg'
import _imports_5 from '@/assets/icons/warnerror.svg'
import _imports_6 from '@/assets/icons/mailsent.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", {
  class: "modal-title",
  id: "assignadmintitle"
}, "ASSIGN COMPANY ADMIN", -1)
const _hoisted_2 = { class: "modalbody" }
const _hoisted_3 = {
  key: 0,
  class: "radioflowdiv"
}
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "divlblfont mb-3" }, " Admin rights will be assigned to new user after users's account is activated", -1)
const _hoisted_6 = {
  key: 1,
  style: {"height":"90%"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "bottommargin titlestyle" }, "Select existing users", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"25px"},
  title: "searchimg",
  alt: "searchimg"
}, null, -1)
const _hoisted_9 = { class: "adminoverflowdiv" }
const _hoisted_10 = { class: "tblabelfont" }
const _hoisted_11 = {
  key: 0,
  class: "pagingdiv"
}
const _hoisted_12 = { class: "pagelabel" }
const _hoisted_13 = {
  key: 0,
  src: _imports_1,
  style: {"width":"20px"},
  alt: "fpenabledimg",
  title: "fpenabledimg"
}
const _hoisted_14 = {
  key: 1,
  src: _imports_2,
  style: {"width":"20px"},
  alt: "fpdisabledimg",
  title: "fpdisabledimg"
}
const _hoisted_15 = {
  key: 0,
  src: _imports_3,
  style: {"width":"20px"},
  alt: "lpenabledimg",
  title: "lpenabledimg"
}
const _hoisted_16 = {
  key: 1,
  src: _imports_4,
  style: {"width":"20px"},
  alt: "lpdisabledimg",
  title: "lpdisabledimg"
}
const _hoisted_17 = { key: 2 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "bottommargin titlestyle" }, "Invite new user", -1)
const _hoisted_19 = { class: "fieldLength" }
const _hoisted_20 = { class: "fieldLength" }
const _hoisted_21 = { class: "fieldLength" }
const _hoisted_22 = {
  key: 0,
  class: "errordiv emailerror"
}
const _hoisted_23 = {
  key: 1,
  class: "errordiv"
}
const _hoisted_24 = {
  key: 3,
  class: "maxitemsdiv errordiv"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "warnimagestyle",
  alt: "warnimg",
  title: "warnimg"
}, null, -1)
const _hoisted_26 = { style: {"padding":"1rem 0"} }
const _hoisted_27 = { key: 4 }
const _hoisted_28 = { class: "labeldiv" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  style: {"width":"70px","margin-bottom":"1rem"},
  alt: "mailsentimg",
  title: "mailsentimg"
}, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "labelbld" }, "Email invitation and admin notification sent to: ", -1)
const _hoisted_31 = {
  key: 0,
  style: {"display":"flex","flex-direction":"column"}
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_33 = {
  key: 1,
  style: {"display":"flex"}
}
const _hoisted_34 = { class: "labelfont" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_36 = { class: "buttonsdiv" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_ctx.displayOption === 'radioSelection')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_el_radio, {
              id: "selectexistinguser",
              modelValue: _ctx.selectAssignOption,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectAssignOption) = $event)),
              label: "existingUser",
              onChange: _ctx.selectionChanged
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Assign admin from existing users")
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_button, {
                round: "",
                id: "assignadmin",
                class: "btnstyle btnsize ml-4",
                variant: "warning",
                onClick: _ctx.assignExisting,
                disabled: _ctx.selectAssignOption === 'newUser'
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Assign Admin ")
                ]),
                _: 1
              }, 8, ["onClick", "disabled"])
            ]),
            _createVNode(_component_el_radio, {
              id: "addnewadmin",
              modelValue: _ctx.selectAssignOption,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectAssignOption) = $event)),
              label: "newUser",
              onChange: _ctx.selectionChanged
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Assign admin from new user")
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"]),
            _createElementVNode("div", {
              class: _normalizeClass(
          _ctx.showLightFont ? 'radiodiv lblfontlight' : 'radiodiv lblfontdark'
        )
            }, [
              _hoisted_5,
              _createVNode(_component_el_button, {
                round: "",
                id: "newadmin",
                class: "btnstyle ml-4",
                variant: "warning",
                onClick: _ctx.assignNewUser,
                disabled: _ctx.selectAssignOption === 'existingUser'
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Invite new user ")
                ]),
                _: 1
              }, 8, ["onClick", "disabled"])
            ], 2)
          ]))
        : _createCommentVNode("", true),
      (_ctx.displayOption === 'existingUsers')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_el_input, {
              id: "companyusersearch",
              modelValue: _ctx.userSearchValue,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.userSearchValue) = $event)),
              placeholder: "Search",
              type: "search",
              debounce: "1000",
              class: "rightmargin inpstyle bottommargin"
            }, {
              suffix: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                id: "companyusertable",
                data: _ctx.existingUsers,
                border: "",
                style: {"width":"100%"},
                "show-header": false,
                "row-style": _ctx.rowdatastyle,
                onSelect: _ctx.handleSelectionChange,
                onSelectAll: _ctx.handleSelectionChange,
                "default-sort": { prop: 'email', order: 'ascending' },
                "empty-text": "Users not Available"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    type: "selection",
                    width: "55"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "User Name",
                    prop: "email",
                    sortable: ""
                  }, {
                    default: _withCtx((props) => [
                      _createElementVNode("div", null, [
                        _createElementVNode("label", _hoisted_10, _toDisplayString(props.row.firstName) + " " + _toDisplayString(props.row.lastName), 1),
                        _createTextVNode(" (" + _toDisplayString(props.row.email) + " ) ", 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data", "row-style", "onSelect", "onSelectAll"])), [
                [_directive_loading, _ctx.loading]
              ])
            ]),
            (_ctx.totalPages > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("label", _hoisted_12, [
                    _createElementVNode("strong", null, "Page " + _toDisplayString(_ctx.currentPage) + " / " + _toDisplayString(_ctx.totalPages), 1)
                  ]),
                  _createVNode(_component_el_button, {
                    plain: "",
                    class: "paginationbtn",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.currentPage = 1)),
                    id: "firstpage",
                    disabled: _ctx.currentPage === 1
                  }, {
                    default: _withCtx(() => [
                      (_ctx.currentPage !== 1)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_13))
                        : _createCommentVNode("", true),
                      (_ctx.currentPage === 1)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_14))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_el_pagination, {
                    layout: "prev, next",
                    total: _ctx.totalRowsCount,
                    "page-size": 10,
                    "current-page": _ctx.currentPage,
                    "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.currentPage) = $event))
                  }, null, 8, ["total", "current-page"]),
                  _createVNode(_component_el_button, {
                    plain: "",
                    class: "paginationbtn",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.currentPage = _ctx.totalPages)),
                    id: "lastpage",
                    disabled: _ctx.currentPage === _ctx.totalPages
                  }, {
                    default: _withCtx(() => [
                      (_ctx.currentPage !== _ctx.totalPages)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_15))
                        : _createCommentVNode("", true),
                      (_ctx.currentPage === _ctx.totalPages)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_16))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.displayOption === 'newUser')
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _hoisted_18,
            _createVNode(_component_el_form, {
              "label-width": "auto",
              "label-position": "top",
              size: "default",
              class: "topmargin"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "Company",
                  class: "firstLetterCapital"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      id: "selectedadmincompany",
                      modelValue: _ctx.selectedCompany,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedCompany) = $event)),
                      class: "user-inputstyle",
                      size: "large",
                      disabled: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companyData, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: index,
                            label: item.companyName,
                            value: item.companyValue
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "First Name",
                  class: "firstLetterCapital"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      id: "adminfirstname",
                      required: "",
                      modelValue: _ctx.inviteData.firstName,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.inviteData.firstName) = $event)),
                      placeholder: "First Name",
                      maxLength: _ctx.maxNameLength,
                      class: "user-inputstyle"
                    }, null, 8, ["modelValue", "maxLength"]),
                    _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.maxNameLength - _ctx.inviteData.firstName.length) + " / " + _toDisplayString(_ctx.maxNameLength), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "Last Name",
                  class: "firstLetterCapital"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      id: "adminlastname",
                      required: "",
                      modelValue: _ctx.inviteData.lastName,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.inviteData.lastName) = $event)),
                      placeholder: "Last Name",
                      maxLength: _ctx.maxNameLength,
                      class: "user-inputstyle"
                    }, null, 8, ["modelValue", "maxLength"]),
                    _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.maxNameLength - _ctx.inviteData.lastName.length) + " / " + _toDisplayString(_ctx.maxNameLength), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "Email address",
                  class: "firstLetterCapital"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      id: "adminemail",
                      required: "",
                      modelValue: _ctx.inviteData.email,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.inviteData.email) = $event)),
                      placeholder: "Enter Email",
                      maxLength: _ctx.maxEmailLength,
                      class: "user-inputstyle"
                    }, null, 8, ["modelValue", "maxLength"]),
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.maxEmailLength - _ctx.inviteData.email.length) + " / " + _toDisplayString(_ctx.maxEmailLength), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.noemail)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, " Please enter the valid email address "))
              : _createCommentVNode("", true),
            (_ctx.hasError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, "All the fields are required!"))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.showError && _ctx.addUserError !== '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.addUserError), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.displayOption === 'emailSent')
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _hoisted_30,
              (_ctx.inviteData.email.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedUsers, (item, index) => {
                      return (_openBlock(), _createElementBlock("p", {
                        class: "labelfont",
                        key: index
                      }, [
                        _createElementVNode("strong", null, _toDisplayString(item.firstName) + " " + _toDisplayString(item.lastName), 1),
                        _hoisted_32,
                        _createTextVNode(" (" + _toDisplayString(item.email) + " ) ", 1)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.inviteData.email.length !== 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _createElementVNode("p", _hoisted_34, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.inviteData.firstName) + " " + _toDisplayString(_ctx.inviteData.lastName), 1),
                      _hoisted_35,
                      _createTextVNode(" (" + _toDisplayString(_ctx.inviteData.email) + " ) ", 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_36, [
        (
          _ctx.displayOption !== 'emailSent' && _ctx.displayOption === 'existingUsers'
        )
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              id: "adminexistingnext",
              round: "",
              class: "btnstyle ml-4",
              variant: "warning",
              onClick: _ctx.nextClickHandler,
              disabled: !_ctx.enableControls || _ctx.selectedUsers.length === 0,
              loading: !_ctx.enableControls && !_ctx.showError
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Next ")
              ]),
              _: 1
            }, 8, ["onClick", "disabled", "loading"]))
          : _createCommentVNode("", true),
        (_ctx.displayOption !== 'emailSent' && _ctx.displayOption === 'newUser')
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              id: "adminnewnext",
              round: "",
              class: "btnstyle ml-4",
              variant: "warning",
              onClick: _ctx.nextClickHandler,
              disabled: !_ctx.enableControls && _ctx.inviteData.firstName !== '',
              loading: !_ctx.enableControls && !_ctx.showError
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Next ")
              ]),
              _: 1
            }, 8, ["onClick", "disabled", "loading"]))
          : _createCommentVNode("", true),
        (_ctx.displayOption !== 'emailSent')
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 2,
              id: "admincancel",
              round: "",
              variant: "outline-dark",
              onClick: _ctx.closeModal,
              class: "cancelbtn"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Cancel ")
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (_ctx.displayOption === 'emailSent')
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 3,
              id: "admindone",
              round: "",
              class: "btnstyle ml-4",
              variant: "warning",
              onClick: _ctx.closeModal
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Done ")
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}